import React from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "../services/apiMethods";
import moment from "moment";

export default function AllTeamMembers() {
    const Navigate = useNavigate();
     const Location = useLocation()
    const { data: electricianProfile, error, isLoading, refetch } = useQuery({
        queryKey: ["electricianProfile"],
        queryFn: () => getRequest(`profile/view/vendor${Location?.search}`),
        enabled: !!Location?.search,
    });

    return (
        <>
            <Layout>
                <Container>
                    <div className="dashboard-main">
                        <h3
                            className="with-back-btn cursor-pointer"
                            onClick={() => Navigate(-1)}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                                    fill="black"
                                />
                            </svg>
                            Back
                        </h3>
                        <Row>
                            <div className="portfolio-data">
                                <h3 className="mb-4 ">Our Team</h3>
                            </div>
                            {Array.isArray(electricianProfile?.data?.employees) && electricianProfile?.data?.employees.length > 0 ?
                                <>
                                    {electricianProfile?.data?.employees.map((ele, index) => {
                                        return (
                                            <Col lg={3} key={index}>
                                                <div className="team-member-detail">
                                                    <div className="team-member-img">
                                                        <img src={ele?.image ? ele?.image : require("../assets/images/vector-logo.svg").default} />
                                                    </div>
                                                    <h2>{ele?.employeeName}</h2>
                                                    <p>{ele?.jobRole}</p>
                                                    <p>Since {ele?.createdAt ? moment(ele?.createdAt).format('MMMM YYYY') : "N/A"} </p>
                                                </div>
                                            </Col>
                                        )
                                    })}
                                </>

                                :
                                <p> No Data Found</p>}

                        </Row>
                    </div>
                </Container>
            </Layout>
        </>
    );
}
